import {
    KOREA_REVENUE_BY_CUSTOMER_SUCCESS,
    KOREA_REVENUE_BY_CUSTOMER_LOADING,
  } from '../actions/KoreaRevenueByCustomerAction';
  
  const initialState = {
    revenueByCustomerData: [],
    isLoading: true
  };
  
  const KoreaRevenueByCustomerReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case KOREA_REVENUE_BY_CUSTOMER_SUCCESS:
        return { ...state, revenueByCustomerData: action.data, isLoading: false };
      case KOREA_REVENUE_BY_CUSTOMER_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default KoreaRevenueByCustomerReducer;
  